module.exports = __webpack_public_path__ + "static/media/amazonLogo.1eac87f3.svg";